import { Maybe } from '../../types/utility'

export const clearSpaces = (value: Maybe<string>) => {
  return value?.toString().replace(/ /g, '') ?? ''
}
